import { ArrowLeft, Globe } from "@phosphor-icons/react";
import { useParams } from "react-router-dom";
import {
    useDataSourceById,
    useDataSourceCalculations,
} from "../api/data-sources";
import ContentContainer from "../components/ContentContainer";
import EmissionsFactorTimeline from "../components/EmissionsFactorTimeline";
import IconButton from "../components/IconButton";
import MainLayout from "../components/MainLayout";
import Separator from "../components/Separator";
import Typography from "../components/Typography";

const DataSourceEmissionsFactorHistoryPage = () => {
    const { id } = useParams();

    const { dataSource, isLoading: isLoadingDataSource } = useDataSourceById(
        Number(id)
    );
    const { calculations, isLoading: isLoadingCalculations } =
        useDataSourceCalculations(Number(id));

    if (!id) return null;

    return (
        <MainLayout isLoading={isLoadingCalculations || isLoadingDataSource}>
            {!dataSource && (
                <ContentContainer className="py-10 text-center">
                    <p>No data source found matching this id</p>
                </ContentContainer>
            )}
            {dataSource && (
                <ContentContainer className="pt-14 pb-11">
                    <div className="flex flex-col gap-6 sm:gap-0 sm:flex-row items-center pb-5">
                        <div className="flex items-center">
                            <IconButton
                                label="Back"
                                icon={ArrowLeft}
                                iconSize="large"
                                className="mr-3"
                                onClick={() => window.history.back()}
                            />
                            <Typography variant="headline-small" component="h1">
                                Emissions factor history
                            </Typography>
                        </div>
                        <div className="ml-auto flex items-center gap-2 font-semibold">
                            <Globe weight="light" size={24} />
                            <Typography
                                variant="headline-small"
                                component="span"
                                className="text-deep-ocean-20"
                            >
                                Scope {dataSource?.scope}
                            </Typography>
                        </div>
                    </div>
                    <Separator className="mb-8" />
                    <Typography
                        variant="title-large"
                        component="h2"
                        className="text-deep-ocean-20"
                    >
                        {dataSource?.name}
                    </Typography>
                    <Separator className="my-8" />
                    <EmissionsFactorTimeline calculations={calculations} />
                </ContentContainer>
            )}
        </MainLayout>
    );
};

export default DataSourceEmissionsFactorHistoryPage;
